import React from "react";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";

import {
  Tooltip,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { isMobile } from "../../globalStyles/mobile";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EEEEEE",
    border: "1px solid #EAECF0",
    color: theme.palette.common.black,
    padding: "4px",
    textAlign: "start",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
    textAlign: "start",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--bg-paper)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const TransactionList = ({ data, viewMode, currentPage, itemsPerPage }) => {
  const startIndex = currentPage * itemsPerPage;

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {data?.map((item, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid #D0D5DD",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="#333333"
                >
                  {startIndex + index + 1}
                </Typography>
              </div>
              <Grid container spacing={1}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Payment Id
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    : {item?.paymentId}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Payer Name
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    :{" "}
                    {`${item?.additional_info?.payer?.name?.given_name || ""} ${
                      item?.additional_info?.payer?.name?.surname || ""
                    }`}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Payer Address
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    : {item?.additional_info?.payer?.address?.country_code}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Amount
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    : {item?.amount}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Currency
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    : {item?.currency}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Status
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    : {item?.status?.toLowerCase()}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      <TableContainer
        sx={{
          overflowY: "auto",
          paddingInline: 0.4,
          maxHeight: "100%",
        }}
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{
            border: "1px solid #EAECF0",
          }}
        >
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  SL NO
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  PAYMENT ID
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  PAYER NAME
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  PAYER ADDRESS
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  AMOUNT
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  CURRENCY
                </Typography>
              </StyledTableCell>

              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="#333333"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  STATUS
                </Typography>
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {data?.map((carrier, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {startIndex + index + 1}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {carrier.paymentId}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {`${
                      carrier?.additional_info?.payer?.name?.given_name || ""
                    } ${carrier?.additional_info?.payer?.name?.surname || ""}`}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {carrier?.additional_info?.payer?.address?.country_code ||
                      ""}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {carrier.amount}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {carrier.currency}
                  </Typography>
                </StyledTableCell>

                <StyledTableCell>
                  <Typography
                    fontSize="12px"
                    color="#667085"
                    fontWeight={400}
                    fontFamily={"Poppins"}
                  >
                    {carrier.status?.toLowerCase()}
                  </Typography>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      <div
        style={{
          overflowY: "scroll",
          display: "flex",
          maxHeight: isMobile() ? "60vh" : `calc(100vh - 250px)`,
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::WebkitScrollbar": { width: 0 },
        }}
      >
        {viewMode === "grid" || isMobile()
          ? renderGridView()
          : renderListView()}
      </div>
    </div>
  );
};

export default TransactionList;
